
import { useSyncExternalStoreWithSelector } from 'use-sync-external-store/with-selector';
import { Store, Observe } from './types';

export const createObserve = <StateType, StateSlice>(
  store: Store<StateType>,
): Observe<Store<StateType>> => {
  const observe = (
    selector: (state: StateType) => StateSlice,
    equalityFn?: (a: StateSlice, b: StateSlice) => boolean,
  ) =>
    useSyncExternalStoreWithSelector(
      store.subscribe,
      store.getState,
      store.getState,
      selector,
      equalityFn,
    );

  return observe as Observe<Store<StateType>>;
};
